import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <p>
        © {currentYear} Score My Offer. All rights reserved.
        <span className="footer-divider">·</span>
        <Link to="/terms" className="footer-link" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</Link>
        <span className="footer-divider">·</span>
        <Link to="/privacy" className="footer-link" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
      </p>
    </footer>
  );
};

export default Footer;
